<!-- Start -->
<section class="relative lg:pt-24 pt-[74px] overflow-hidden">
  <div class="container-fluid lg:px-10 md:px-3 relative overflow-hidden">
    <span class="absolute blur-[200px] w-[600px] h-[600px] rounded-full top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2"></span>
    <div class="lg:py-24 py-[74px] md:rounded-lg shadow dark:shadow-gray-800 bg-[url('/assets/images/parallax/trojan1_1920x1200.jpg')] bg-no-repeat bg-center bg-cover">
      <div class="container">
        <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
          <div class="md:col-span-7">
            <div class="md:me-6">
              <h4 class="font-bold lg:leading-snug leading-snug text-4xl lg:text-6xl mb-4"><span class="bg-gradient-to-l from-red-600 to-violet-600 text-transparent bg-clip-text">{{ "HOME.GAME_NAME" | translate }}</span><br />Play now</h4>
              <p class="text-lg max-w-xl">{{ "HOME.GAME_DESCRIPTION" | translate }}</p>

              <div class="mt-6">
                <a [routerLink]="'/download'" class="btn bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white rounded-full me-2 mt-2">
                  {{ 'HOME.DOWNLOAD' | translate }}
                </a>
                <a *ngIf="!isAuthenticated" [routerLink]="'/login'" class="btn bg-transparent hover:bg-violet-600 border-violet-600 text-violet-600 hover:text-white rounded-full mt-2">
                  {{ 'HOME.SIGN_IN' | translate }}
                </a>
                <a *ngIf="isAuthenticated" [routerLink]="'/user/conquer-accounts'" class="btn bg-transparent hover:bg-violet-600 border-violet-600 text-violet-600 hover:text-white rounded-full mt-2">
                  {{ 'HOME.CREATE_CHARACTER' | translate }}
                </a>
              </div>
            </div>
            <div class="overflow-hidden after:content-[''] after:absolute after:h-10 after:w-10 after:bg-violet-600/10 dark:after:bg-violet-600/30 after:-bottom-[50px] after:start-[30%] after:-z-1 after:rounded-full after:animate-ping"></div>
          </div><!--end col-->
        </div><!--end grid-->
      </div><!--end container-->
    </div><!--end -->
  </div><!--end container fluid-->
</section><!--end section-->
<!-- End -->

<!-- Start -->
<section class="relative md:py-24 py-16">
  <div class="container">
    <div class="grid grid-cols-1 pb-8 text-center">
      <h3 class="mb-4 md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">{{ 'HOME.LATEST_NEWS' | translate }}</h3>
    </div><!--end grid-->

    <app-blog/>
  </div><!--end container-->

  <div class="container md:mt-24 mt-16">
    <div class="grid grid-cols-1 text-center">
      <h3 class="mb-4 md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">{{ "HOME.ABOUT_THE_GAME" | translate }}</h3>

      <p class="text-slate-400 max-w-xl mx-auto">{{ "HOME.ABOUT_THE_GAME_CONTENT" | translate }}</p>
    </div><!--end grid-->

    @defer {
      <app-about/>
    }
  </div><!--end container-->

</section><!--end section-->
<!-- End -->
